<script setup>
const emit = defineEmits(['finished-typing', 'typing']);
const model = defineModel();
const props = defineProps({
    id: {
        type: String,
        default: '',
        required: false,
    },
    name: {
        type: String,
        default: '',
        required: false,
    },
    placeholder: {
        type: String,
        default: '',
        required: false,
    },
    min: {
        type: String,
        default: null,
        required: false,
    },
    max: {
        type: String,
        default: null,
        required: false,
    },
    required: {
        type: Boolean,
        default: false,
        required: false,
    },
    debounce: {
        type: Number,
        default: 1000,
        required: false,
    },
    disabled: {
        type: Boolean,
        default: false,
        required: false,
    },
    type: {
        type: String,
        default: 'date',
        required: false,
    }
});

let emitFinishedTyping = null;

const onInput = (e) => {
    clearTimeout(emitFinishedTyping);

    emit('typing', e.target.value);

    emitFinishedTyping = setTimeout(() => {
        emit('finished-typing', e.target.value);
    }, props.debounce);
}
</script>

<template>
    <input
        type="date"
        v-model="model"
        @input="onInput"
        :id="id"
        :name="name"
        :placeholder="placeholder"
        :required="required"
        :min="min"
        :max="max"
        :disabled="disabled"
        class="
        disabled:opacity-70 disabled:bg-gray
        block w-full rounded-lg focus:outline-none
        placeholder:text-black/40
        border-0 ring-1 ring-inset ring-black/20
        focus:ring-2 focus:ring-black/30
        invalid:focus:ring-rose-200 invalid:focus:border-rose-600
        group-invalid:focus:ring-rose-200 group-invalid:focus:border-rose-600
        bg-white text-slate-500
        [color-scheme:light]
        " />
</template>

<style scoped>
input[type="date"]::-webkit-calendar-picker-indicator {
    filter: invert(60%) sepia(9%) saturate(340%) hue-rotate(179deg) brightness(88%) contrast(82%);
    cursor: pointer;
}

input[type="date"] {
    color-scheme: light;
}
</style>
